<template>
  <div class="profile-basic-details">
    <SectionThreeItemsHeader class="mb-6 mt-2">
      <template v-slot:item-center>
        <h2>Languages</h2>
      </template>
      <template v-slot:item-right>
        <EditLanguagesAndSkillsAction v-if="isEditable" />
      </template>
    </SectionThreeItemsHeader>
    <Permissioned section="workers.view" vertical>
      <LanguageList :userId="userData.id" :permission="permissions.languages" />
      <SkillList :userId="userData.id" :permission="permissions.skills" />
    </Permissioned>
  </div>
</template>

<script>
import Permissioned from "@/components/common/Permissioned";
import SectionThreeItemsHeader from "@/components/common/SectionThreeItemsHeader/SectionThreeItemsHeader";
import EditLanguagesAndSkillsAction from "@/views/settings/components/actions/EditLanguagesAndSkillsAction";
import LanguageList from "@/components/workers/languages/LanguageList";
import SkillList from "@/components/workers/skills/SkillList";
import { PERMISSIONS } from "@/constants/workers";

export default {
  components: {
    Permissioned,
    EditLanguagesAndSkillsAction,
    SectionThreeItemsHeader,
    LanguageList,
    SkillList
  },
  props: {
    userData: {
      type: Object,
      required: true
    },
    isEditable: Boolean
  },
  data() {
    return {
      permissions: PERMISSIONS.LANGUAGES_AND_SKILLS
    };
  }
};
</script>

<style lang="scss"></style>
